import React from 'react'
import './Test.scss'

const Test = () => {
  return (
    <div>Test</div>
  )
}

export default Test